import React from "react";
import { Euro, Home, Person, Work } from "@mui/icons-material";
const sections = [
  {
    id: "home",
    title: "Accueil",
    description: "Découvrez notre univers et nos valeurs fondamentales.",
    fullDescription: `
      <section id="zeva" style="padding: 2rem 1rem;">
      <h2>🌿 ZEVA</h2>
      <p><strong>ZEVA</strong> est une <strong>approche personnelle</strong> que j’utilise pour illustrer ce que vous pouvez vivre et explorer au fil des séances.<br>
      Il s’agit d’un <strong>acronyme symbolique</strong>, pensé pour vous aider à mieux saisir les <strong>bénéfices concrets</strong> d’un accompagnement en thérapie cognitive et comportementale (TCC).</p>

      <div>
        <h3>🧘‍♀️ Zénitude</h3>
        <p>Un espace apaisant et confidentiel pour se déposer, respirer, ralentir.<br>
        <strong>→ Retrouver du calme intérieur, en toute sécurité.</strong></p>

        <h3>🧩 Évolution</h3>
        <p>Un cheminement progressif pour mieux cerner vos pensées, émotions et comportements.<br>
        <strong>→ Gagner en compréhension de soi et avancer avec plus de sérénité.</strong>
        </p>

        <h3>❤️ Valeurs</h3>
        <p>Identifier ce qui a du sens pour vous, au-delà du mal-être.<br>
        <strong>→ Revenir à l’essentiel, à vos repères personnels.</strong></p>

        <h3>🚀 Action</h3>
        <p>Des pistes concrètes, adaptées et progressives, à explorer entre les séances.<br>
        <strong>→ Se remettre en mouvement, à son rythme.</strong></p>
      </div>

      <hr style="margin: 2rem 0;">

      <h2>💬 Mon approche thérapeutique</h2>
      <p>J’accorde une importance primordiale à la <strong>dimension humaine</strong> dans ma pratique, en offrant un <strong>espace d’écoute bienveillant et sans jugement</strong>.</p>
      <p>Chaque accompagnement est guidé par le <strong>respect</strong>, l’<strong>empathie</strong> et une <strong>approche scientifique rigoureuse</strong>, afin d’apporter des réponses adaptées aux besoins uniques de chacun.</p>
      <p><strong>👉 Mon engagement :</strong><br>
      <strong>Accompagner chaque personne vers un mieux-être</strong>, en valorisant ses ressources et son potentiel.</p>
    </section>

      `,
    background: "linear-gradient(155deg, #201b14 0%, #3a3125 100%)",
    image: "/Images/Others/mains.png",
    icon: React.createElement(Home),
  },
  {
    id: "about",
    title: "À propos",
    description: "Apprenez-en plus sur mon parcours et mon expertise.",
    fullDescription: `
      Psychologue clinicienne spécialisée en psychopathologie psychanalytique et en thérapies cognitives et comportementales (TCC), j’ai développé une expertise variée à travers mon parcours en milieu hospitalier et médico-social. J’ai eu l’opportunité d’accompagner des enfants, des adolescents, des adultes et des seniors dans des domaines tels que la psychiatrie, la neurologie, l’addictologie et l’accompagnement du handicap.<br/><br/>
      Ma pratique s’articule autour de la prise en charge des troubles anxieux, des troubles de l’humeur, du stress et du burn-out, des troubles du comportement alimentaire, ainsi que des troubles relationnels et émotionnels. J’interviens également dans le traitement des troubles du comportement et de l’impulsivité, des troubles du sommeil et des troubles psychosomatiques.<br/><br/>
      Adoptant une approche intégrative, je combine une compréhension approfondie des mécanismes psychiques avec des outils thérapeutiques concrets pour proposer un accompagnement personnalisé. Mon objectif est d’aider chacun à mieux comprendre son fonctionnement, à surmonter ses difficultés et à retrouver un équilibre personnel et relationnel, que ce soit en cabinet ou en téléconsultation.
    `,
    background: "linear-gradient(155deg, #241f18 0%, #423722 100%)",
    image: "/Images/face/photo-nawel-bouchoukh.png",
    icon: React.createElement(Person),
  },
  {
    id: "services",
    title: "Services",
    description: "Explorez les services et accompagnements proposés.",
    fullDescription: `
      <b>Consultations et suivis thérapeutiques : </b><br/>
      Je propose des séances individuelles pour enfants, adolescents, adultes et seniors, visant à traiter et adapter les comportements problématiques. Ces interventions sont conçues pour identifier les schémas comportementaux inadaptés et mettre en place des stratégies thérapeutiques personnalisées, favorisant des changements positifs et durables.
      <br/><br/>
      
      <b>Bilans psychologiques : </b><br/>
      Des évaluations approfondies sont réalisées pour analyser les aspects cognitifs, émotionnels et comportementaux de chaque individu. Ces bilans permettent de dresser un profil précis, facilitant l'élaboration d'un plan d'intervention ciblé et efficace.
      <br/><br/>
      <b>Remédiation cognitive : </b><br/>
      J'élabore des programmes personnalisés visant à améliorer les fonctions cognitives telles que la mémoire, l'attention et les compétences exécutives. Cette approche est particulièrement bénéfique pour les personnes rencontrant des difficultés cognitives impactant leur quotidien.
      <br/><br/>
      <b>Accompagnement psychoéducatif : </b><br/>
      Je propose un accompagnement adapté pour les personnes avec des troubles du spectre de l'autisme (TSA). Cet accompagnement vise à développer les compétences communicationnelles, sociales et comportementales, en collaboration étroite avec les familles et les éducateurs.
      <br/><br/>
      <b>Thérapie de couple et familiale : </b><br/>
      J'interviens auprès des couples et des familles pour améliorer la communication, résoudre les conflits et renforcer les liens affectifs. Grâce à une approche systémique, les séances visent à comprendre les dynamiques relationnelles et à instaurer un équilibre harmonieux au sein du foyer.
      `,
    background: "linear-gradient(155deg, #1f1a13 0%, #35301f 100%)",
    image: "/Images/logos/logo-zeva.png",
    icon: React.createElement(Work),
  },

  {
    id: "tarifs",
    title: "Tarifs",
    description: "Découvrez nos tarifs.",
    fullDescription: `
    <div>
      <h2>Tarifs</h2>

      <hr aria-hidden="true" />
      <div>Première consultation individuelle <b>70 €</b></div>

      <hr aria-hidden="true" />
      <div>Première consultation (Thérapie de couple ou Thérapie familiale) <b>100 €</b></div>

      <hr aria-hidden="true" />
      <div>Consultation individuelle de suivi <b>65 €</b></div>

      <hr aria-hidden="true" />
      <div>Consultation de suivi (Thérapie de couple ou Thérapie familiale) <b>90 €</b></div>

      <hr aria-hidden="true" />
      <div>Accompagnement Psychologique à Domicile – Enfant, Sénior ET/OU en Situation de Handicap <b>70 € à 100 €</b></div>
    </div>

    `,
    background: "linear-gradient(155deg, #262019 0%, #3f3626 100%)",
    image: "/Images/Others/pierres.png",
    icon: React.createElement(Euro),
  },
];

export default sections;
